import { DATES_ERROR, DATES_RECEIVE, DATES_REQUEST } from './DatesAction'

const initialState = {
	dates:[],
	datesTimeRanges:{}
}

const DatesReducer = (state = initialState, action = {}) => {
	const { type,error,dates } = action

	switch (type) {
		// ------------------------------------ dates fetch ------------------------------------
		case DATES_REQUEST:
			return {
				...state,
				isDatesFetching: true
			}
		case DATES_RECEIVE:
			return {
				...state,
				isDatesFetching: false,
				dates:Object.keys(dates),
				datesTimeRanges:dates
			}
		case DATES_ERROR:
			return {
				...state,
				isDatesFetching: false,
				error
			}

		default:
			return state
	}
}

export default DatesReducer
